import React from 'react';
import { Link } from 'react-router-dom';

const TextTabsList = ({tabs, type, id}) => (
    <ul className="text-tabs__tabs__list">
        {tabs.map(tab => 
            <li key={tab.index} className={`text-tabs__tabs__list-item ${id === tab.index.toString() ? 'active' : ''}`}>
                <Link className="text-tabs__tabs__list-item__link" to={`/${type}?id=${tab.index}`}>
                    {tab.title}
                </Link>
            </li>)}
    </ul>
)

export default TextTabsList;
